import { render, staticRenderFns } from "./InventoryFlow.vue?vue&type=template&id=5b2e632c&scoped=true&"
import script from "./InventoryFlow.vue?vue&type=script&lang=js&"
export * from "./InventoryFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e632c",
  null
  
)

export default component.exports